import React, { useMemo } from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import { mapContainerStyle, mapDarkStyles } from './constants';

export const MapPreview = ({ lat, lng, name }) => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
  });

  const center = useMemo(() => ({ lat, lng }), [lat, lng]);

  if (!isLoaded || !lat || !lng) return null;

  return (
    <div className="mt-3 rounded-lg overflow-hidden border border-slate-700">
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        center={center}
        zoom={15}
        options={{
          disableDefaultUI: true,
          zoomControl: true,
          styles: mapDarkStyles,
        }}
      >
        <Marker position={center} title={name} />
      </GoogleMap>
    </div>
  );
};
